import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  scheduleAppointmentButton: {
    defaultMessage: 'Schedule Appointment',
    id: '6ElJSh',
    description: 'Button text for scheduling appointment',
  },
  completeSetup: {
    defaultMessage: 'Complete Setup',
    id: '723HFT',
    description: 'Complete setup button text',
  },
});
